import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieBanner.css';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleRefuse = () => {
    localStorage.setItem('cookie_consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <p>
        Ce site utilise des cookies pour améliorer votre expérience.{' '}
        <Link to="/mentions-legales">En savoir plus</Link>
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-refuse" onClick={handleRefuse}>
          Refuser
        </button>
        <button className="cookie-btn cookie-accept" onClick={handleAccept}>
          Accepter
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
